import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { of } from 'rxjs';

export type TrixelInteraction = 'ListView' | 'Click' | 'View';

@Injectable({
  providedIn: 'root',
})
export class ClixelService {
  private readonly httpClient = inject(HttpClient);

  public logEventInTrixels(url: string, category?: string, interaction?: TrixelInteraction, referringCategory?: string) {
    // This is what i would like to use but the enpoint doesn't support post currently navigator.sendBeacon(this.trixelUrl);
    return url ? this.httpClient.get(this.formatTrixelUrl(url, category, interaction, referringCategory), { responseType: 'blob' }) : of();
  }

  public formatTrixelUrl(trixelUrl: string, category?: string, interaction?: TrixelInteraction, referringCategory?: string): string {
    const url = new URL(trixelUrl);

    if (category) {
      url.searchParams.set('c', category);
    } else if (!url.searchParams.has('c')) {
      console.error('Category must be passed to clixel.');
    }

    if (interaction) {
      url.searchParams.set('i', interaction);
    }

    if (referringCategory) {
      url.searchParams.set('rc', referringCategory);
    }

    return url.toString();
  }
}
